<template>
    <div>
        <div v-if="formSeteo" class="container form-registro p-0">
            <div class="d-flex justify-content-between" style="background: #fafafa; border-bottom: 2px solid #efefef;">
                <h5 class="ml-4 mb-0 py-2 text-muted">Obtener nueva contraseña</h5>
                <button @click="irLogin()" class="px-4 btn btn-link text-primary" style="text-decoration-line: underline;"><i class="d-none fas fa-long-arrow-alt-left"></i><span class="" style="font-size:.8rem; font-weight:500">Iniciar sesion</span></button>
            </div>
            <div class="padding-seteo pt-2 pb-4">
                <form v-on:submit.prevent="obtenerContraseña()">
                    <div v-if="error_seteoPass == 2" class="alert alert-danger" role="alert">
                        Error al enviar contraseña. Correo no registrado.
                    </div>
                    <div class="row mt-3">
                        <div class="col-md-12 d-flex justify-content-center">
                            <p class="text-mail">
                                Estimado usuario deberá introducir la dirección de correo electrónico que ingresó durante el proceso de registro para hacerle llegar su nueva contraseña.
                            </p>
                        </div>
                    </div>
                    <div class="d-flex flex-column align-items-center mt-2 correoUsuario">
                        <div class="input-group inputActivacion">
                            <input type="text" v-model.trim="correo_usuario" class="form-control form-control-lg text-center" id="codigo" placeholder="Ingrese su correo electrónico">
                            <div class="input-group-append">
                                <button type="submit" class="btn btn-vino botonSetear">Obtener contraseña</button>
                            </div>
                        </div>
                        <p v-if="error_seteoPass == 1" class="small text-danger my-0"> *Ingrese la direción de correo electrónico</p>
                    </div>
                </form>
            </div>
        </div>
            <div v-show="loading_seteo" style="margin: 5.5rem 0">
                <spiner></spiner>
                <!-- <div v-if="maxHeight && flagLogin == false" style="padding-bottom:7%;"></div>                 -->
            </div>
        <!-- Pantalla de confirmación -->
        <div v-if="confirmacionEnvPass" v-scroll-reveal>
            <div class="container mt-3 p-0 mb-5 finalizarSeteo" style="border-radius:5px; border: 2px solid #c4c3c3;">
                    <div class="pt-5 text-white text-center" style="color: #02a443; /*background:#02a443 !important;*/ border-top-left-radius:5px; border-top-right-radius:5px;">
                        <i class="text-success far fa-check-circle fa-4x mb-4"></i>
                        <p class="h3 ml-2 p-0 text-success mb-4 text-center" style="color: #7f7d88; font-size:21px">Contraseña enviada correctamente</p>
                    </div>
                    <div class="text-center px-5 pb-5 mb-0">
                        <p class="m-0 paddingFinalizar h6 pt-2 px-3" style="color:#a29b9b;">Estimado usuario, su nueva contraseña fue enviada al correo electrónico que ingreso anteriormente, verifique la bandeja de entrada.Se le sugiere cambiar la contraseña enviada por una más fácil de recordar</p> <!----Se le sugiere cambiarla por una contraseña más facil de recordar----->
                        <button type="button" @click="irLogin()" class="btn btn-primary px-5 py-2">Iniciar sesión</button>
                    </div>
            </div>
        </div>
    </div>
</template>
<script>
import spiner from "./../../spiner.vue"
import axios from "axios";
import AutorizacionTramiteshacienda from "./../../../services/autorizacionTramites";
const _servicesAuth = new AutorizacionTramiteshacienda();
export default {
    name: 'seteo-password',
    data: function(){
        return{
            token_auth:'',
            correo_usuario:'',
            formSeteo: true,
            confirmacionEnvPass: false,
            error_seteoPass: 0,
            loading_seteo: false,
        }
    },components:{
        spiner,
    },
    created: function(){
        this.getTokenAuthServe();
    },
    methods:{
        irLogin: function(){
            this.$emit('ver_login', true);
        },
        getTokenAuthServe: async function(){
           let result = null;
            result = await _servicesAuth.GetTokenServer2();
            if(result.success)
            {
                this.token_auth = result.data;
            }
            else{ console.log(result.error); }
        },
        obtenerContraseña: function(){
            if (this.correo_usuario === "") {
                this.error_seteoPass = 1;
            } else{
                this.formSeteo = false;
                this.loading_seteo = true;
                // let datos = JSON.stringify(this.correo_usuario);
                let config_Serve = {
                    method: 'put',
                    url: this.$urlServidor+'key/api/Auth/Reset_password',
                    headers: {
                        'Authorization' : 'Bearer' + ' ' + this.token_auth,
                        'Content-Type': 'application/json'
                    },
                    data : { correo: this.correo_usuario, apikey: "B6B08AF9-7917-4882-80F0-16222E792944" }

                };
                 axios(config_Serve)
                .then(response => {
                    this.loading_seteo = false;
                    //console.log(response);
                    if (response) {
                        this.confirmacionEnvPass = true;
                        console.log('modificado');
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.formSeteo = true;
                    this.loading_seteo = false;
                    this.error_seteoPass = 2;
                });

            }
        }
    }
}
</script>
<style scoped>
    .form-registro{
        /**max-width: 1000px !important;**/
        margin-top: 3rem;
        margin-bottom: 5rem;
        border: 2px solid #efefef;
        border-radius: 5px;
        /* padding: 2rem 3rem 3rem 3rem; */
        border-left: 5px solid #7f2535;
    }
    .correoUsuario ::placeholder{
        color: #d1cfcf;
        font-weight: 400;
    }
    .padding-seteo{ padding: 3rem 3rem;}
    .inputActivacion{ width: 50%; }
    .text-mail{
        font-weight: 400;
        color: #868686;
        text-align: center !important;
    }
    /* pantalla de confirmación */
    .finalizarSeteo{ width: 50%; }
    .paddingFinalizar{ padding:3rem; }

/* ########### MEDIA QUERYS <900PX (CELULARES) ############# */
@media only screen and (max-device-width : 900px){
    .padding-seteo{ padding: 1.5rem 1rem;}
    .inputActivacion{ width: 100%; }
    .correoUsuario ::placeholder{ font-size: .9rem; }
    .botonSetear{font-size: 0.73rem; padding: 0.2rem;}

    /* Pantalla de confirmación */
    .finalizarSeteo{ width: 100%; }
    .paddingFinalizar{ padding:2rem 0; }
}
</style>
